import {webserverServiceProUrl} from './index';
import {getDefaultOpts} from '../index';
import {IChecksumResponse, ITemplateChecksumRequest} from '@elproag/webserver-service-pro';
import {TimeRange} from '../../../components/Infrastructure/DateTime/TimeRange';
import dayjs from 'dayjs';

const baseUrl = `${webserverServiceProUrl}/api/web/devices`;

export async function CalculateConfigurationChecksum(configuration: ITemplateChecksumRequest): Promise<string> {
	const response = await fetch(`${baseUrl}/templates/checksum`, {
		...getDefaultOpts(),
		method: 'POST',
		body: JSON.stringify(configuration),
	});

	if (!response.ok) {
		console.error(await response.text());
		throw new Error(`Failed to calculate configuration checksum: ${response.statusText}`);
	}

	const result = (await response.json()) as IChecksumResponse;
	return result.checksum;
}

export async function CalculateDeviceChecksum(serialNumber: string, sensor_ids: number[]): Promise<string> {
	const queryParams = sensor_ids.map(id => `sensorIds=${id}`).join('&');
	const response = await fetch(`${baseUrl}/${serialNumber}/checksum?${queryParams}`, {
		...getDefaultOpts(),
		method: 'GET',
	});

	if (!response.ok) {
		console.error(await response.text());
		throw new Error(`Failed to calculate device checksum: ${response.statusText}`);
	}

	const result = (await response.json()) as IChecksumResponse;
	return result.checksum;
}

export async function GetDeviceInspectionRange(serialNumber: string, sensorId: number): Promise<TimeRange> {
	const response = await fetch(`${baseUrl}/${serialNumber}/sensors/${sensorId}/inspectionRange`, {
		...getDefaultOpts(),
		method: 'GET',
	});

	if (!response.ok) {
		console.error(await response.text());
		throw new Error(`Failed to get device inspection range: ${response.statusText}`);
	}

	const result = await response.json();

	return new TimeRange(dayjs(result.start), dayjs(result.end));
}

export async function GetDeviceAvailability(serialNumber: string): Promise<boolean> {
	const response = await fetch(`${baseUrl}/${serialNumber}/availability`, {
		...getDefaultOpts(),
		method: 'GET',
	});

	if (!response.ok) {
		console.error(await response.text());
		throw new Error(`Failed to get device availability: ${response.statusText}`);
	}

	const result = await response.json();
	return result.isAvailable;
}
